import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Logical, PageCategory, Widget } from "../../../widgetList/widgetList";
import { LinkData } from "../LinkForm";
import TopPanel, { Panel } from "../TopPanel";
import CloseIcon from "../../icons/CloseIcon";
import { ProductItemGet } from "../../../types/product";
import ProductSearch from "../../ProductSearch";
import FormInputItem from "../../FormInputItem";
import ProductsDefaultSettings from "../ProductsDefaultSettings";
import LogicBuilderForHalalflix from "../../LogicBuilderForHalalflix";
import { RootState } from "../../../app/store";

interface ProductItemsType {
  custom?: number[];
  logical?: Logical;
}

interface TabType {
  name: string;
  logo?: string;
  src?: string;
  link?: LinkData;
  products?: ProductItemsType;
  product?: ProductItemGet;
  customLink?: string;
  outboundLink?: string | ProductItemGet;
  linkType?: "product" | "custom";
}

interface Props {
  choosenItem: any; // type: Widget
  onUpdate: (w: Widget) => void;
  countryCode?: string;
}

const FormForHalalflixVideos: FC<Props> = ({
  choosenItem,
  onUpdate,
  countryCode,
}) => {
  const [active, setActive] = useState<boolean>(choosenItem.active);

  const [isSlider, setIsSlider] = useState<boolean>(
    !!choosenItem.data?.isSlider
  );
  const [sourceType, setSourceType] = useState("custom");

  // const [popupElement, setPopupElement] = useState<JSX.Element | null>(null);

  // const [selectedCampaign, setSelectedCampaign] = useState<PageCategory | null>(
  //   null
  // );

  const [panel, setPanel] = useState<Panel>("main");

  const [colProductLimit, setColProductLimit] = useState<number>(
    choosenItem?.data?.settings?.productLimit
  );
  // const [containerType, setContainerType] = useState<"full" | "box">(
  //   (choosenItem as any)?.data?.settings?.containerType || "box"
  // );
  const [settings, setSettings] = useState<any>(
    choosenItem?.data?.settings as any
  );

  //   const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
  //     e.preventDefault();

  //     const widgetObj: any = {
  //       name: choosenItem.name,
  //       active: active,
  //       data: {
  //         selectedCampaign:
  //           selectedCampaign || choosenItem?.data?.selectedCampaign || null,
  //         tabs: videoTabs,
  //         title: title,
  //         settings: {
  //           productLimit: colProductLimit,
  //           ...settings,
  //           containerType: containerType,
  //         },
  //       },
  //       wType: choosenItem.wType,
  //       id: choosenItem.id,
  //     };
  // console.log('widgetObj', widgetObj)
  // // return
  //     onUpdate(widgetObj);
  //   };
  const customProductIds = useSelector(
    (state: RootState) => state.logicBuilder.setting
  );

  useEffect(() => {
    const customLenght: any = choosenItem?.data?.setting?.custom?.length;
    if (customLenght > 0) {
      setSourceType("custom");
    } else {
      setSourceType("logical");
    }
  }, [choosenItem]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    console.log("customProductIds =", customProductIds);

    const widgetObj: any = {
      name: "halalflix-videos",
      active: active,
      data: {
        images: [],
        setting:
          sourceType === "custom"
            ? { custom: customProductIds.custom, logical: {} }
            : { custom: [], logical: customProductIds.logical },
        isSlider: isSlider,
        // selectedCampaign:
        //   selectedCampaign || choosenItem?.data?.selectedCampaign || null,
        settings: {
          productLimit: colProductLimit,
          ...settings,
        },
      },
      wType: choosenItem.wType,
      id: choosenItem.id,
    };
    onUpdate(widgetObj);
  };

  return (
    <>
      {choosenItem.name === "halalflix-videos" ? (
        <form onSubmit={handleSubmit} className="mainSliderForm__container">
          <h1 className="title capitalize">halalflix slider</h1>

          <TopPanel panel={panel} onChange={(name) => setPanel(name)} />

          <div>
            <div className="flex items-center gap-4">
              <div
                onClick={() => setIsSlider(!isSlider)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <div>Is Slider : </div>
                <div
                  className={`w-5 h-5 rounded-md ${
                    isSlider
                      ? "bg-green-500 shadow"
                      : "bg-gray-300 shadow-inner"
                  }`}
                ></div>
              </div>
            </div>
          </div>

          {panel === "main" ? (
            <div>
              {/* <div className="flex flex-col items-start gap-4 mt-3 pt-2 border-t">
                <CampaignSelector
                  initialCampaign={choosenItem?.data?.selectedCampaign || null}
                  onUpdate={(data) => {
                    setSelectedCampaign(data);
                  }}
                />
              </div> */}
              

              <div className="flex flex-col items-start gap-4">
                <div>Source type : </div>
                <div className="flex items-center gap-4">
                  <div
                    onClick={() => setSourceType("logical")}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <div
                      className={`w-5 h-5 rounded-md ${
                        sourceType === "logical"
                          ? "bg-green-500 shadow"
                          : "bg-gray-300 shadow-inner"
                      }`}
                    ></div>
                    <div>Logical</div>
                  </div>
                  <div
                    onClick={() => setSourceType("custom")}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <div
                      className={`w-5 h-5 rounded-md ${
                        sourceType === "custom"
                          ? "bg-green-500 shadow"
                          : "bg-gray-300 shadow-inner"
                      }`}
                    ></div>
                    <div>Custom</div>
                  </div>
                </div>
              </div>

              <LogicBuilderForHalalflix
                sourceType={sourceType}
                choosenItem={choosenItem}
              />
            </div>
          ) : (
            <div className="flex flex-col items-start gap-4 mt-3 pt-2 border-t">
              {/* <div className="flex items-center gap-4">
                <div>Product Limit : </div>
                <input
                  className="w-20"
                  type="number"
                  value={colProductLimit}
                  onChange={(e) => setColProductLimit(Number(e.target.value))}
                />
              </div> */}

              <ProductsDefaultSettings
                settings={settings}
                onChange={(key, value) => {
                  setSettings({
                    ...settings,
                    [key]: value,
                  });
                }}
              />
            </div>
          )}

          <div>
            <button className="mainSliderForm__btn">save</button>
          </div>
        </form>
      ) : (
        <div className="flex items-center justify-center text-sm font-light tracking-wide text-red-500 h-52">
          Please check widget name!
        </div>
      )}
    </>
  );
};

export default FormForHalalflixVideos;
